import palette from '../palette';

export default {
  root: {
    fontSize: 12,
    height: 66,
    '&$selected': {
      backgroundColor: palette.background.default,
    },
    '&$hover': {
      '&:hover': {
        backgroundColor: palette.background.default,
      },
    },
  },
};
